<template>
  <div class="term">
    <h1>SHIPPING & DELIVERY POLICY</h1>

    <div class="banner h-[200px] md:h-[350px]" style="background: url('/img/term-shippingbanner.jpg') no-repeat center center; background-size: cover">
    </div>

    <h2>Delivery</h2>

    <div>
      At CEL-ELEMENTS HOLDINGS (M) SDN BHD, we provide shipment on all our products to buyers to the areas and states that can be selected when choosing the shipping address. Currently, the parcels are shipped by Nationwide Express Courier Services Berhad. All purchases will only be delivered upon full payment and clearance via the online payment gateway.
    </div>
    <div>
      Deliveries will be made within 2-3 working days from the time of
      successful order. All mentioned delivery terms (shipping days, delivery
      time in working days, shipment date etc.) on the website should be
      understood as estimated delivery terms and cannot be understood as final
      delivery terms or guaranteed delivery terms.
    </div>

    <div>
      The buyer bears the responsibility for the correct input of the delivery
      address; in case anything goes wrong with the shipment of an order due to
      an error in the delivery address made by the buyer, CEL-ELEMENTS HOLDINGS
      (M) SDN BHD cannot be held responsible for the (partial) loss of the
      shipment. In case CEL-ELEMENTS HOLDINGS (M) SDN BHD needs additional
      information regarding a delivery address, the buyer may be approached by
      CEL-ELEMENTS HOLDINGS (M) SDN BHD in order to provide additional
      information. A delay in the delivery may occur in case additional
      information regarding the delivery address is needed.
    </div>
    <div>
      CEL-ELEMENTS HOLDINGS (M) SDN BHD will use all reasonable efforts to
      deliver the order within the expected delivery terms to the delivery
      address. CEL-ELEMENTS HOLDINGS (M) SDN BHD cannot be held liable for any
      delays in the delivery of an order.
    </div>
    <div>
      If delivery suffers a delay, or if the delivery cannot be implemented, or
      only partially, the buyer will be informed about this as soon as
      reasonably possible after the order has been placed. In this case,
      CEL-ELEMENTS HOLDINGS (M) SDN BHD will do its best to resolve the issue.
    </div>
    <div>
      In case a shipment still has not been delivered at the delivery address of
      the buyer (or the pickup point) 14 days after the shipment date, the buyer
      has the obligation to inform the CEL-ELEMENTS HOLDINGS (M) SDN BHD’s
      customer service team by email within 14 days (so: ultimately 28 days
      after the shipment date).
    </div>
    <div>
      We try our best to prepare your orders and send them out as soon as we
      can, but orders can only be shipped during working days and hours. We hope
      our beloved customers might note that CEL-ELEMENTS HOLDINGS (M) SDN BHD
      does not represent courier companies, and as much as we hope for parcels
      to arrive on time, parcels can suffer delays beyond our control. However,
      please rest assured that we are on your side and will help in any way we
      can.
    </div>
    <div>
      Office Hours are from Monday to Friday, 9 am-6 pm, excluding Public
      Holidays.
    </div>

    <h2>SHIPPING FEES & CHARGES</h2>

    <div>
      Up till the present moment, our customers can enjoy a FREE shipping fee
      for all purchases made on Cel-Elements’s official website until further
      notice.
    </div>

    <div>
      You may contact our customer service team by emailing your inquiry to
      info@cel-elements.com and our customer service team will contact you
      during working days and hours.
    </div>
  </div>
</template>

<style>
.term h1,
.term h2 {
  @apply mb-2 px-4 font-semibold;
}

.term div {
  @apply mb-4;
}

.term div:not(.banner) {
  @apply px-4;
}
</style>
